.wordmark {
  color: var(--zumpo-ink);
  font: var(--zumpo-text-brand);
  letter-spacing: var(--zumpo-text-brand-tracking);
  white-space: nowrap;
}

.dot {
  color: var(--zumpo-coral);
}
